// extracted by mini-css-extract-plugin
export default {"volumeControl":"jukebox-volume-control_volumeControl__WlaUI","iconBtn":"jukebox-volume-control_iconBtn__3Q8jG","slider":"jukebox-volume-control_slider__MBDze"};